import React from 'react';
import ServicesLayout from '../../../components/ServicesLayout/ServicesLayout';
import ServiceCardsEditor from './ServiceCardsEditor';
import { isAdminUser, isDistrictAdminUser } from '../../../lib/utils';

const title = 'Karty eusług';


export default {

  path: '/service_cards_editor',
  children: [
    {
      path: '/',
      async action(ctx) {
        const { query, store } = ctx;
        const service = query.serviceType;
        const district = query.district;
        const isAdmin = await isAdminUser(ctx);
        let isDistrictAdmin = null;
        if (!isAdmin) {
          isDistrictAdmin = await isDistrictAdminUser(ctx);
          if (!isDistrictAdmin) {
            return { redirect: '/' };
          }
        }
        return {
          title,
          chunk: 'ServiceCardsEditor',
          component: <ServicesLayout isAdmin><ServiceCardsEditor title={title} serviceType={service} district={district} /></ServicesLayout>,
        };
      },
    },
  ],
};



// WEBPACK FOOTER //
// src/routes/admin/service_cards_editor/index.js